import { render, staticRenderFns } from "./disbursements.vue?vue&type=template&id=deb7a196&"
import script from "./disbursements.vue?vue&type=script&lang=js&"
export * from "./disbursements.vue?vue&type=script&lang=js&"
import style0 from "./disbursements.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports